import { render } from "./miniWishlist.vue?vue&type=template&id=64c64f64"
import script from "./miniWishlist.vue?vue&type=script&lang=js"
export * from "./miniWishlist.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__